import React from "react";

import { queries } from "src/modules/kd/patient-list/queries";
import {
	useDesktopColumnProps,
	useMobileColumnProps
} from "src/modules/kd/patient-list/useColumnProps";
import { useNormalizePatient } from "src/modules/kd/patient-list/useNormalizePatient";
import { PatientList as PatientListShared } from "src/modules/shared/patient-list";

export const PatientList: React.FunctionComponent = () => {
	const normalizePatient = useNormalizePatient();
	const columns = useDesktopColumnProps();
	const mobile = useMobileColumnProps();
	return (
		<PatientListShared
			queries={queries}
			desktopColumns={columns}
			mobileColumns={mobile}
			initialSortKey={"modifTime"}
			initialSortDirection={"desc"}
			normalizePatient={normalizePatient}
		/>
	);
};
